import { render, staticRenderFns } from "./ibItem.vue?vue&type=template&id=5fb5790c&"
import script from "./ibItem.vue?vue&type=script&lang=js&"
export * from "./ibItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports